export default "__VITE_ASSET__65841f4d__"